// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Db$Coronate from "./Db.res.js";
import * as PervasivesU from "rescript/lib/es6/pervasivesU.js";
import * as ReactFeather from "react-feather";
import * as Utils$Coronate from "./Utils.res.js";
import * as Router$Coronate from "./Router.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as HtmlEntities$Coronate from "./HtmlEntities.res.js";

function Pages$Splash(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("aside", {
                      children: [
                        JsxRuntime.jsxs("ol", {
                              children: [
                                JsxRuntime.jsxs("li", {
                                      children: [
                                        JsxRuntime.jsx("button", {
                                              children: "Click here to load the demo data",
                                              className: "button-primary",
                                              onClick: (function (param) {
                                                  Db$Coronate.loadDemoDB();
                                                })
                                            }),
                                        " (optional)"
                                      ],
                                      className: "pages__hint-item"
                                    }),
                                JsxRuntime.jsxs("li", {
                                      children: [
                                        JsxRuntime.jsx(ReactFeather.ArrowLeft, {}),
                                        " Select a menu item."
                                      ],
                                      className: "pages__hint-item"
                                    }),
                                JsxRuntime.jsx("li", {
                                      children: "Start creating your tournaments!",
                                      className: "pages__hint-item"
                                    })
                              ]
                            }),
                        JsxRuntime.jsx(Utils$Coronate.$$Notification.make, {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("p", {
                                            children: [
                                              "Coronate does not require an account.",
                                              JsxRuntime.jsx("br", {}),
                                              "It saves your data locally in your browser."
                                            ]
                                          }),
                                      JsxRuntime.jsxs("p", {
                                            children: [
                                              "To manage your data, visit the ",
                                              JsxRuntime.jsx(Router$Coronate.Link.make, {
                                                    children: "Options",
                                                    to_: "Options"
                                                  }),
                                              " page."
                                            ]
                                          })
                                    ]
                                  }),
                              kind: "Warning"
                            })
                      ],
                      className: "pages__hint"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("img", {
                                    alt: "",
                                    height: "96",
                                    src: Utils$Coronate.WebpackAssets.logo,
                                    width: "96"
                                  }),
                              className: "pages__title-icon"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h1", {
                                      children: "Coronate",
                                      className: "title",
                                      style: {
                                        fontSize: "40px"
                                      }
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Tournament manager",
                                      className: "pages__subtitle caption-30"
                                    })
                              ],
                              className: "pages__title-text"
                            })
                      ],
                      className: "pages__title"
                    }),
                JsxRuntime.jsxs("footer", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: "Do you enjoy using Coronate?"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: JsxRuntime.jsx("a", {
                                            children: JsxRuntime.jsx("img", {
                                                  style: {
                                                    height: "60px",
                                                    width: "217px"
                                                  },
                                                  alt: "Buy Me A Coffee",
                                                  height: "60",
                                                  src: Utils$Coronate.WebpackAssets.buyMeACoffee,
                                                  width: "217"
                                                }),
                                            href: "https://www.buymeacoffee.com/johnridesabike",
                                            target: "_blank"
                                          })
                                    })
                              ],
                              className: "pages__footer-left"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: "Copyright " + HtmlEntities$Coronate.copy + " John Jackson."
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: JsxRuntime.jsx("a", {
                                            children: "Suggestions and bug reports are welcome.",
                                            className: "pages__footer-link",
                                            href: Utils$Coronate.issues_url
                                          })
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Coronate is free software."
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("a", {
                                              children: "Source code is available",
                                              className: "pages__footer-link",
                                              href: Utils$Coronate.github_url
                                            }),
                                        " under the ",
                                        JsxRuntime.jsx("a", {
                                              children: "Mozilla Public License 2.0",
                                              className: "pages__footer-link",
                                              href: Utils$Coronate.license_url
                                            }),
                                        "."
                                      ]
                                    })
                              ],
                              className: "pages__footer-right"
                            })
                      ],
                      className: "pages__footer body-20"
                    })
              ],
              className: "pages__container"
            });
}

var Splash = {
  make: Pages$Splash
};

function log2(num) {
  return Math.log(num) / Math.log(2.0);
}

function fixNumber(num) {
  if (num < 0.0 || num === PervasivesU.infinity || num === PervasivesU.neg_infinity) {
    return 0.0;
  } else {
    return num;
  }
}

function updateInt(dispatch, minimum, $$event) {
  $$event.preventDefault();
  var value = Belt_Option.getWithDefault(Belt_Int.fromString($$event.currentTarget.value), minimum);
  var safeValue = value < minimum ? minimum : value;
  return dispatch(function (param) {
              return safeValue;
            });
}

var title = "Time calculator";

function Pages$TimeCalculator(props) {
  var match = React.useState(function () {
        return 2;
      });
  var setPlayers = match[1];
  var players = match[0];
  var match$1 = React.useState(function () {
        return 5;
      });
  var setBreakTime = match$1[1];
  var breakTime = match$1[0];
  var match$2 = React.useState(function () {
        return 4.0;
      });
  var setTotalTime = match$2[1];
  var totalTime = match$2[0];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h1", {
                      children: title
                    }),
                JsxRuntime.jsx("p", {
                      children: "Estimate the time requirements for planning your Swiss-system tournament.",
                      className: "caption-30"
                    }),
                JsxRuntime.jsx("form", {
                      children: JsxRuntime.jsx("table", {
                            children: JsxRuntime.jsxs("tbody", {
                                  children: [
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsx("label", {
                                                        children: "Player count ",
                                                        htmlFor: "playerCount"
                                                      })
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsx("input", {
                                                        id: "playerCount",
                                                        style: {
                                                          width: "40px"
                                                        },
                                                        min: String(0),
                                                        type: "number",
                                                        value: String(players),
                                                        onChange: (function (extra) {
                                                            return updateInt(setPlayers, 0, extra);
                                                          })
                                                      })
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsx("label", {
                                                        children: "Breaks between rounds ",
                                                        htmlFor: "breakTime"
                                                      })
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    JsxRuntime.jsx("input", {
                                                          id: "breakTime",
                                                          style: {
                                                            width: "40px"
                                                          },
                                                          min: String(0),
                                                          step: 5.0,
                                                          type: "number",
                                                          value: String(breakTime),
                                                          onChange: (function (extra) {
                                                              return updateInt(setBreakTime, 0, extra);
                                                            })
                                                        }),
                                                    " minutes"
                                                  ]
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsx("label", {
                                                        children: "Total time available ",
                                                        htmlFor: "totalTime"
                                                      })
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    JsxRuntime.jsx("input", {
                                                          id: "totalTime",
                                                          style: {
                                                            width: "40px"
                                                          },
                                                          min: String(0.5),
                                                          step: 0.5,
                                                          type: "number",
                                                          value: String(totalTime),
                                                          onChange: (function (extra) {
                                                              var minimum = 0.5;
                                                              extra.preventDefault();
                                                              var value = Belt_Option.getWithDefault(Belt_Float.fromString(extra.currentTarget.value), minimum);
                                                              var safeValue = value < minimum ? minimum : value;
                                                              return setTotalTime(function (param) {
                                                                          return safeValue;
                                                                        });
                                                            })
                                                        }),
                                                    " hours"
                                                  ]
                                                })
                                          ]
                                        })
                                  ]
                                }),
                            style: {
                              margin: "0"
                            }
                          })
                    }),
                JsxRuntime.jsxs("dl", {
                      children: [
                        JsxRuntime.jsx("dt", {
                              children: "Round count",
                              className: "title-20"
                            }),
                        JsxRuntime.jsx("dd", {
                              children: fixNumber(Math.ceil(log2(players)))
                            }),
                        JsxRuntime.jsx("dt", {
                              children: "Maximum time control",
                              className: "title-20"
                            }),
                        JsxRuntime.jsxs("dd", {
                              children: [
                                JsxRuntime.jsxs("span", {
                                      children: [
                                        fixNumber(Math.ceil((totalTime * 60.0 / Math.ceil(log2(players)) - breakTime) / 2.0)),
                                        " minutes"
                                      ],
                                      className: "title-20"
                                    }),
                                JsxRuntime.jsxs("span", {
                                      children: [
                                        " = ((",
                                        JsxRuntime.jsx("strong", {
                                              children: totalTime,
                                              className: "monospace"
                                            }),
                                        " × 60 ÷ ⌈log₂(",
                                        JsxRuntime.jsx("strong", {
                                              children: players,
                                              className: "monospace"
                                            }),
                                        ")⌉) - ",
                                        JsxRuntime.jsx("strong", {
                                              children: breakTime,
                                              className: "monospace"
                                            }),
                                        ") ÷ 2"
                                      ],
                                      className: "caption-20"
                                    })
                              ]
                            })
                      ]
                    })
              ],
              className: "content-area"
            });
}

function Pages$NotFound(props) {
  return JsxRuntime.jsx("p", {
              children: "Page not found.",
              className: "content-area"
            });
}

var NotFound = {
  make: Pages$NotFound
};

var TimeCalculator = {
  title: title,
  make: Pages$TimeCalculator
};

export {
  Splash ,
  TimeCalculator ,
  NotFound ,
}
/* react Not a pure module */
